import { Space, Typography } from 'antd';
import { useTheme } from 'styled-components';
import { getPlaceholderCategoryMetadata } from './placeholderCategoryRegistry.tsx';
import { type PlaceholderCategory } from './types.ts';

interface Props {
  category: PlaceholderCategory;
}

export function PlaceholderCategoryTitle(props: Props) {
  const { category } = props;
  const theme = useTheme();
  const metadata = getPlaceholderCategoryMetadata(category);

  return (
    <>
      <Space>
        {metadata.icon}
        <Typography.Text strong style={{ color: theme.colorPrimary }}>
          {metadata.label}
        </Typography.Text>
      </Space>
      {metadata.description && (
        <div style={{ marginTop: '4px' }}>
          <Typography.Text type="secondary">
            {metadata.description}
          </Typography.Text>
        </div>
      )}
    </>
  );
}
